// 机构路由

export default [
	//==人员管理==
	{
		name: '基本信息',
		path: '/personnel/information',
		component: () => import('@/views/mechanism/personnel/information.vue'),
	},
	{
		name: '在职从业人员管理',
		path: '/personnel/onJob',
		component: () => import('@/views/mechanism/personnel/onJob.vue'),
	},
	{
		name: '离职人员管理',
		path: '/personnel/outJob',
		component: () => import('@/views/mechanism/personnel/outJob.vue'),
	},
	{
		name: '黑名单人员管理',
		path: '/personnel/badMen',
		component: () => import('@/views/mechanism/personnel/badMen.vue'),
	},
	//==课程监管==
	{
		name: '课程管理',
		path: '/supervise/curriculum',
		component: () => import('@/views/mechanism/supervise/curriculum.vue'),
	},
	{
		name: '开课列表',
		path: '/supervise/openClass',
		component: () => import('@/views/mechanism/supervise/openClass.vue'),
	},
	{
		name: '材料管理',
		path: '/supervise/material',
		component: () => import('@/views/mechanism/supervise/material.vue'),
	},
	//==延时课表==
	{
		name: '延时课表',
		path: '/timetable',
		component: () => import('@/views/mechanism/timetable/index.vue'),
	},
	//==运营管理==
	{
		name: '支付渠道管理',
		path: '/operate/payChannel',
		component: () => import('@/views/mechanism/operate/payChannel/index.vue'),
	},
	{
		name: '支付宝支付',
		path: '/operate/payChannel/alipay',
		component: () => import('@/views/mechanism/operate/payChannel/alipay.vue'),
	},
	{
		name: '微信支付',
		path: '/operate/payChannel/wechat',
		component: () => import('@/views/mechanism/operate/payChannel/wechat.vue'),
	},
	{
		name: '订单管理',
		path: '/cost/order',
		component: () => import('@/views/mechanism/operate/cost/order.vue'),
	},
	{
		name: '课酬管理',
		path: '/cost/classPay',
		component: () => import('@/views/mechanism/operate/cost/classPay.vue'),
	},
	{
		name: '结算管理',
		path: '/cost/settlement',
		component: () => import('@/views/mechanism/operate/cost/settlement.vue'),
	},
	{
		name: '评价管理',
		path: '/operate/evaluate',
		component: () => import('@/views/mechanism/operate/evaluate/index.vue'),
	},
	{
		name: '课程投诉管理',
		path: '/complaint/class',
		component: () => import('@/views/mechanism/operate/complaint/class.vue'),
	},
	{
		name: '教师投诉管理',
		path: '/complaint/teacher',
		component: () => import('@/views/mechanism/operate/complaint/teacher.vue'),
	},
	{
		name: '收费投诉管理',
		path: '/complaint/charge',
		component: () => import('@/views/mechanism/operate/complaint/charge.vue'),
	},
	//==统计分析==
	{
		name: '课程开班统计',
		path: '/statistical/openClass',
		component: () => import('@/views/mechanism/statistical/openClass/index.vue'),
	},
	{
		name: '课程评价统计',
		path: '/statistical/evaluate',
		component: () => import('@/views/mechanism/statistical/evaluate/index.vue'),
	},
	{
		name: '教师考勤统计',
		path: '/statistical/teacher',
		component: () => import('@/views/mechanism/statistical/teacherAttendance/index.vue'),
	},
	{
		name: '学生考勤统计',
		path: '/statistical/studnetAttendance',
		component: () => import('@/views/mechanism/statistical/studnetAttendance/index.vue'),
	},
	//==通知公告==
	{
		name: '通知公告',
		path: '/notice',
		component: () => import('@/views/mechanism/notice/index.vue'),
	},
	//==首页(机构)==
	{
		name: '首页概览',
		path: '/homeViews',
		component: () => import('@/views/mechanism/homePage/index.vue'),
	},
];

